/**
 * Generated from PostcardTokyo2Layout.fla
 */
export function PostcardTokyo2Layout(this: IPostcardTokyo2Layout) {
	const main = this.main;
	PostcardTokyo2Layout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function PostcardTokyo2Layout_main(this: IPostcardTokyo2Layout_main) {
	const postcard = this.postcard;
	PostcardTokyo2Layout_postcard.call(this.postcard);
	postcard.x = 0;
	postcard.y = 4.7;
	if (postcard.scale) postcard.scale.x = 0.633;
	if (postcard.scale) postcard.scale.y = 0.633;
	if (postcard.onLayout) postcard.onLayout();
	return this;
}
function PostcardTokyo2Layout_postcard(this: IPostcardTokyo2Layout_postcard) {
	const cardTransform = this.cardTransform;
	if (!cardTransform[0] && cardTransform.elementFactory) {
		cardTransform[0] = cardTransform.elementFactory(0,undefined);
	}
	if (cardTransform[0]) {
		PostcardTokyo2Layout_cardTransform1.call(cardTransform[0] as IPostcardTokyo2Layout_cardTransform1);
		cardTransform[0].x = -594.3;
		cardTransform[0].y = 281.55;
		cardTransform[0].width = 569.88;
		cardTransform[0].height = 714.33;
		if (cardTransform[0].onLayout) cardTransform[0].onLayout();
	}
	if (!cardTransform[1] && cardTransform.elementFactory) {
		cardTransform[1] = cardTransform.elementFactory(1,undefined);
	}
	if (cardTransform[1]) {
		PostcardTokyo2Layout_cardTransform2.call(cardTransform[1] as IPostcardTokyo2Layout_cardTransform2);
		cardTransform[1].x = 499.7;
		cardTransform[1].y = -410.95;
		cardTransform[1].rotation = -0.0000;
		cardTransform[1].width = 503.16;
		cardTransform[1].height = 630.70;
		if (cardTransform[1].onLayout) cardTransform[1].onLayout();
	}
	if (!cardTransform[2] && cardTransform.elementFactory) {
		cardTransform[2] = cardTransform.elementFactory(2,undefined);
	}
	if (cardTransform[2]) {
		PostcardTokyo2Layout_cardTransform3.call(cardTransform[2] as IPostcardTokyo2Layout_cardTransform3);
		cardTransform[2].x = -116.05;
		cardTransform[2].y = 315.5;
		cardTransform[2].width = 539.58;
		cardTransform[2].height = 676.35;
		if (cardTransform[2].onLayout) cardTransform[2].onLayout();
	}
	if (!cardTransform[3] && cardTransform.elementFactory) {
		cardTransform[3] = cardTransform.elementFactory(3,undefined);
	}
	if (cardTransform[3]) {
		PostcardTokyo2Layout_cardTransform4.call(cardTransform[3] as IPostcardTokyo2Layout_cardTransform4);
		cardTransform[3].x = -579.8;
		cardTransform[3].y = -316.95;
		cardTransform[3].width = 507.16;
		cardTransform[3].height = 635.69;
		if (cardTransform[3].onLayout) cardTransform[3].onLayout();
	}
	if (!cardTransform[4] && cardTransform.elementFactory) {
		cardTransform[4] = cardTransform.elementFactory(4,undefined);
	}
	if (cardTransform[4]) {
		PostcardTokyo2Layout_cardTransform5.call(cardTransform[4] as IPostcardTokyo2Layout_cardTransform5);
		cardTransform[4].x = 359.4;
		cardTransform[4].y = -59.25;
		cardTransform[4].width = 363.16;
		cardTransform[4].height = 455.21;
		if (cardTransform[4].onLayout) cardTransform[4].onLayout();
	}
	if (!cardTransform[5] && cardTransform.elementFactory) {
		cardTransform[5] = cardTransform.elementFactory(5,undefined);
	}
	if (cardTransform[5]) {
		PostcardTokyo2Layout_cardTransform6.call(cardTransform[5] as IPostcardTokyo2Layout_cardTransform6);
		cardTransform[5].x = -170.45;
		cardTransform[5].y = -200.55;
		cardTransform[5].width = 597.74;
		cardTransform[5].height = 749.25;
		if (cardTransform[5].onLayout) cardTransform[5].onLayout();
	}
	if (!cardTransform[6] && cardTransform.elementFactory) {
		cardTransform[6] = cardTransform.elementFactory(6,undefined);
	}
	if (cardTransform[6]) {
		PostcardTokyo2Layout_cardTransform7.call(cardTransform[6] as IPostcardTokyo2Layout_cardTransform7);
		cardTransform[6].x = 380.75;
		cardTransform[6].y = 272.55;
		cardTransform[6].width = 388.06;
		cardTransform[6].height = 486.42;
		if (cardTransform[6].onLayout) cardTransform[6].onLayout();
	}
	if (!cardTransform[7] && cardTransform.elementFactory) {
		cardTransform[7] = cardTransform.elementFactory(7,undefined);
	}
	if (cardTransform[7]) {
		PostcardTokyo2Layout_cardTransform8.call(cardTransform[7] as IPostcardTokyo2Layout_cardTransform8);
		cardTransform[7].x = 668.7;
		cardTransform[7].y = 271.3;
		cardTransform[7].width = 532.30;
		cardTransform[7].height = 667.22;
		if (cardTransform[7].onLayout) cardTransform[7].onLayout();
	}
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		PostcardTokyo2Layout_pieces4.call(items[0] as IPostcardTokyo2Layout_pieces4);
		items[0].x = -599.6;
		items[0].y = -309.45;
		items[0].width = 499.00;
		items[0].height = 652.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		PostcardTokyo2Layout_outlines4.call(items[1] as IPostcardTokyo2Layout_outlines4);
		items[1].x = -567.8;
		items[1].y = -320.6;
		items[1].width = 395.00;
		items[1].height = 501.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		PostcardTokyo2Layout_pieces5.call(items[2] as IPostcardTokyo2Layout_pieces5);
		items[2].x = 353.85;
		items[2].y = -79.25;
		items[2].width = 456.00;
		items[2].height = 394.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		PostcardTokyo2Layout_outlines5.call(items[3] as IPostcardTokyo2Layout_outlines5);
		items[3].x = 358.6;
		items[3].y = -70.5;
		items[3].width = 215.00;
		items[3].height = 301.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		PostcardTokyo2Layout_pieces3.call(items[4] as IPostcardTokyo2Layout_pieces3);
		items[4].x = -112.5;
		items[4].y = 329.7;
		items[4].width = 436.00;
		items[4].height = 288.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		PostcardTokyo2Layout_outlines3.call(items[5] as IPostcardTokyo2Layout_outlines3);
		items[5].x = -113.3;
		items[5].y = 329.05;
		items[5].width = 434.00;
		items[5].height = 287.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,undefined);
	}
	if (items[6]) {
		PostcardTokyo2Layout_pieces7.call(items[6] as IPostcardTokyo2Layout_pieces7);
		items[6].x = 375.45;
		items[6].y = 269.9;
		items[6].width = 386.00;
		items[6].height = 411.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,undefined);
	}
	if (items[7]) {
		PostcardTokyo2Layout_outlines7.call(items[7] as IPostcardTokyo2Layout_outlines7);
		items[7].x = 384.95;
		items[7].y = 271.45;
		items[7].width = 303.00;
		items[7].height = 256.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,undefined);
	}
	if (items[8]) {
		PostcardTokyo2Layout_pieces8.call(items[8] as IPostcardTokyo2Layout_pieces8);
		items[8].x = 677.35;
		items[8].y = 270.65;
		items[8].width = 234.00;
		items[8].height = 572.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,undefined);
	}
	if (items[9]) {
		PostcardTokyo2Layout_outlines8.call(items[9] as IPostcardTokyo2Layout_outlines8);
		items[9].x = 677.6;
		items[9].y = 271.5;
		items[9].width = 235.00;
		items[9].height = 571.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,undefined);
	}
	if (items[10]) {
		PostcardTokyo2Layout_pieces2.call(items[10] as IPostcardTokyo2Layout_pieces2);
		items[10].x = 501;
		items[10].y = -427.45;
		items[10].width = 1298.96;
		items[10].height = 464.99;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,undefined);
	}
	if (items[11]) {
		PostcardTokyo2Layout_outlines2.call(items[11] as IPostcardTokyo2Layout_outlines2);
		items[11].x = 232;
		items[11].y = -406.75;
		items[11].width = 1281.00;
		items[11].height = 461.00;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,undefined);
	}
	if (items[12]) {
		PostcardTokyo2Layout_pieces6.call(items[12] as IPostcardTokyo2Layout_pieces6);
		items[12].x = -164.8;
		items[12].y = -196.5;
		items[12].width = 473.00;
		items[12].height = 376.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,undefined);
	}
	if (items[13]) {
		PostcardTokyo2Layout_outlines6.call(items[13] as IPostcardTokyo2Layout_outlines6);
		items[13].x = -164.5;
		items[13].y = -195.95;
		items[13].width = 474.00;
		items[13].height = 375.00;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"dependsOn":3,"outlineGlow":false});
	}
	if (items[14]) {
		PostcardTokyo2Layout_pieces1.call(items[14] as IPostcardTokyo2Layout_pieces1);
		(items[14] as IPostcardTokyo2Layout_pieces1).dependsOn = 3;
		(items[14] as IPostcardTokyo2Layout_pieces1).outlineGlow = false;
		items[14].x = -579.45;
		items[14].y = 320.1;
		items[14].width = 456.00;
		items[14].height = 464.00;
		if (items[14].onLayout) items[14].onLayout();
	}
	const background = this.background;
	PostcardTokyo2Layout_background.call(this.background);
	background.x = 0;
	background.y = 0;
	background.width = 1790.00;
	background.height = 1325.00;
	if (background.onLayout) background.onLayout();
	const postcardOverlay = this.postcardOverlay;
	PostcardTokyo2Layout_postcardOverlay.call(this.postcardOverlay);
	postcardOverlay.x = 0;
	postcardOverlay.y = 0;
	postcardOverlay.width = 1784.00;
	postcardOverlay.height = 1318.00;
	if (postcardOverlay.onLayout) postcardOverlay.onLayout();
	const postcardMask = this.postcardMask;
	postcardMask.push(11.60,-642.40,878.60,-641.10,869.70,11.90,875.65,626.30,29.70,629.25,-492.65,638.15,-880.20,652.65,-875.55,-47.50,-881.50,-655.95);
	return this;
}
function PostcardTokyo2Layout_background(this: IPostcardTokyo2Layout_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-tokyo-2.png", 0.500, 0.500);
	return this;
}
function PostcardTokyo2Layout_cardTransform5(this: IPostcardTokyo2Layout_cardTransform5) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-2-5.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo2Layout_cardTransform2(this: IPostcardTokyo2Layout_cardTransform2) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-2-2.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo2Layout_cardTransform4(this: IPostcardTokyo2Layout_cardTransform4) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-2-4.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo2Layout_cardTransform6(this: IPostcardTokyo2Layout_cardTransform6) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-2-6.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo2Layout_cardTransform1(this: IPostcardTokyo2Layout_cardTransform1) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-2-1.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo2Layout_cardTransform3(this: IPostcardTokyo2Layout_cardTransform3) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-2-3.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo2Layout_cardTransform7(this: IPostcardTokyo2Layout_cardTransform7) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-2-7.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo2Layout_cardTransform8(this: IPostcardTokyo2Layout_cardTransform8) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-2-8.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo2Layout_pieces4(this: IPostcardTokyo2Layout_pieces4) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-2-4.png", 0.541, 0.403);
	return this;
}
function PostcardTokyo2Layout_outlines4(this: IPostcardTokyo2Layout_outlines4) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-tokyo-2-4.png", 0.501, 0.501);
	return this;
}
function PostcardTokyo2Layout_pieces5(this: IPostcardTokyo2Layout_pieces5) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-2-5.png", 0.500, 0.500);
	return this;
}
function PostcardTokyo2Layout_outlines5(this: IPostcardTokyo2Layout_outlines5) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-tokyo-2-5.png", 0.502, 0.502);
	return this;
}
function PostcardTokyo2Layout_pieces3(this: IPostcardTokyo2Layout_pieces3) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-2-3.png", 0.500, 0.500);
	return this;
}
function PostcardTokyo2Layout_outlines3(this: IPostcardTokyo2Layout_outlines3) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-tokyo-2-3.png", 0.500, 0.502);
	return this;
}
function PostcardTokyo2Layout_pieces7(this: IPostcardTokyo2Layout_pieces7) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-2-7.png", 0.578, 0.309);
	return this;
}
function PostcardTokyo2Layout_outlines7(this: IPostcardTokyo2Layout_outlines7) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-tokyo-2-7.png", 0.502, 0.500);
	return this;
}
function PostcardTokyo2Layout_pieces8(this: IPostcardTokyo2Layout_pieces8) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-2-8.png", 0.500, 0.500);
	return this;
}
function PostcardTokyo2Layout_outlines8(this: IPostcardTokyo2Layout_outlines8) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-tokyo-2-8.png", 0.502, 0.501);
	return this;
}
function PostcardTokyo2Layout_pieces2(this: IPostcardTokyo2Layout_pieces2) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-2-2.png", 0.717, 0.458);
	return this;
}
function PostcardTokyo2Layout_outlines2(this: IPostcardTokyo2Layout_outlines2) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-tokyo-2-2.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo2Layout_pieces6(this: IPostcardTokyo2Layout_pieces6) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-2-6.png", 0.501, 0.500);
	return this;
}
function PostcardTokyo2Layout_outlines6(this: IPostcardTokyo2Layout_outlines6) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-tokyo-2-6.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo2Layout_pieces1(this: IPostcardTokyo2Layout_pieces1) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-2-1.png", 0.500, 0.500);
	return this;
}
function PostcardTokyo2Layout_postcardOverlay(this: IPostcardTokyo2Layout_postcardOverlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-border.png", 0.500, 0.500);
	return this;
}
function PostcardTokyo2Layout_postcardMask(this: IPostcardTokyo2Layout_postcardMask) {
	return this;
}
interface IPostcardTokyo2LayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPostcardTokyo2LayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPostcardTokyo2LayoutSprite extends IPostcardTokyo2LayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPostcardTokyo2LayoutText extends IPostcardTokyo2LayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPostcardTokyo2LayoutPolygon extends Array<number> {
}
interface IPostcardTokyo2Layout {
	readonly main: IPostcardTokyo2Layout_main;
}
interface IPostcardTokyo2Layout_main extends IPostcardTokyo2LayoutContainer {
	readonly postcard: IPostcardTokyo2Layout_postcard;
}
interface IPostcardTokyo2Layout_postcard extends IPostcardTokyo2LayoutContainer {
	readonly cardTransform: IPostcardTokyo2LayoutArray<IPostcardTokyo2Layout_cardTransform1|IPostcardTokyo2Layout_cardTransform2|IPostcardTokyo2Layout_cardTransform3|IPostcardTokyo2Layout_cardTransform4|IPostcardTokyo2Layout_cardTransform5|IPostcardTokyo2Layout_cardTransform6|IPostcardTokyo2Layout_cardTransform7|IPostcardTokyo2Layout_cardTransform8>;
	readonly items: IPostcardTokyo2LayoutArray<IPostcardTokyo2Layout_pieces4|IPostcardTokyo2Layout_outlines4|IPostcardTokyo2Layout_pieces5|IPostcardTokyo2Layout_outlines5|IPostcardTokyo2Layout_pieces3|IPostcardTokyo2Layout_outlines3|IPostcardTokyo2Layout_pieces7|IPostcardTokyo2Layout_outlines7|IPostcardTokyo2Layout_pieces8|IPostcardTokyo2Layout_outlines8|IPostcardTokyo2Layout_pieces2|IPostcardTokyo2Layout_outlines2|IPostcardTokyo2Layout_pieces6|IPostcardTokyo2Layout_outlines6|IPostcardTokyo2Layout_pieces1>;
	readonly background: IPostcardTokyo2Layout_background;
	readonly postcardOverlay: IPostcardTokyo2Layout_postcardOverlay;
	readonly postcardMask: IPostcardTokyo2Layout_postcardMask;
}
interface IPostcardTokyo2Layout_background extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_cardTransform5 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_cardTransform2 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_cardTransform4 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_cardTransform6 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_cardTransform1 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_cardTransform3 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_cardTransform7 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_cardTransform8 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_pieces4 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_outlines4 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_pieces5 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_outlines5 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_pieces3 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_outlines3 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_pieces7 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_outlines7 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_pieces8 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_outlines8 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_pieces2 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_outlines2 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_pieces6 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_outlines6 extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_pieces1 extends IPostcardTokyo2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardTokyo2Layout_postcardOverlay extends IPostcardTokyo2LayoutSprite {
}
interface IPostcardTokyo2Layout_postcardMask extends IPostcardTokyo2LayoutPolygon {
}
